const faq = {
  getlist: 'faq/getlist-by-admin',
  add: 'faq/add',
  update: 'faq/update',
  remove: 'faq/remove',
  get: 'faq/get',
  clearcache: 'faq/clear-cache',
}
export default faq
